export const LOGIN_SET_LOGIN_OFFLINE = 'LOGIN_SET_LOGIN_OFFLINE';



// WEBPACK FOOTER //
// ./src/pages/login/state/login/types.js